import React, { Component } from 'react';
import './ImageEditWindow.css'
import ImageEditor from './ImageEditor'

class ImageEditWindow extends Component{
    
    constructor(props){
        super(props)
        this.state = {
        }
    }

    closeBoxOnClick=()=>{
        
    }

    getImage=(msg)=>{
        console.log("ImageEditWindow getImage : ")
        console.log(msg)
        this.props.getImage(msg)
    }

    render(){

        console.log("ImageEditWindow render...")
        // let ImageEdit = {
        //     width:"100%",
        //     cursor:"pointer"
        // }

        return(
            <div>
                {this.props.showImageEditor?
                    <div className={"imageEditorWindow"}>
                        <div className ={"rightTopBoxArea"}>
                            <div className = {"rightTopBox"} onClick={this.closeBoxOnClick}>X</div>
                        </div>
                        <ImageEditor getImage={this.getImage} loadImage={this.props.loadImage} loadImageContainerSize={this.props.loadImageContainerSize} editImageSize={this.props.editImageSize}/>
                    </div>
                : null}
            </div>
        )
    }

}

export default ImageEditWindow